export default {
  mapRightClick: {
    'options': 'Beállítások',
    'addDestinationToRoute': 'Hozzáadás további úticélként',
    'directionsFromHere': 'Hozzáadás kiindulási pontként',
    'directionsToHere': 'Hozzáadás úticélként',
    'nonStopDirectionsToHere': 'Hozzáadás közvetlen úticélként',
    'addRouteStop': 'Hozzáadás megállóként',
    'centerHere': 'Legyen itt a középpont',
    'addAsIsochroneCenter': 'Hozzáadás elérhetőségi középpontként',
    'inspectDataOnOSM': 'Adatok megtekintése az OSM-en'
  }
}
